import {
  ConfirmFacebookImportRequestMutation,
  ConfirmFacebookImportRequestMutationVariables
} from './__generated__/ConfirmFacebookImportRequestMutation';
import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { CONFIRM_FACEBOOK_IMPORT_REQUEST_MUTATION } from './confirmFacebookImportRequest.mutation';

interface MutationProps {
  onCompleted: () => void;
  onError: (errors: string[]) => void;
}

export function useConfirmFacebookImportRequest({
  onCompleted,
  onError
}: MutationProps): [(variables: ConfirmFacebookImportRequestMutationVariables) => void, { loading: boolean }] {
  const [confirmFacebookImportRequest, { loading }] = useMutation<
    ConfirmFacebookImportRequestMutation,
    ConfirmFacebookImportRequestMutationVariables
  >(CONFIRM_FACEBOOK_IMPORT_REQUEST_MUTATION, {
    client: kmsClient,
    onCompleted: (data) => {
      if (data.confirmFacebookImportRequest?.errors?.length) {
        onError(data.confirmFacebookImportRequest.errors);
      } else {
        onCompleted();
      }
    },
    onError: (error) => onError([error.message])
  });

  return [
    (variables: ConfirmFacebookImportRequestMutationVariables) => {
      confirmFacebookImportRequest({ variables });
    },
    { loading }
  ];
}
